/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.17.4.0 (NJsonSchema v9.10.46.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
export var GridFilterBasicOperationsEnumeration;
(function (GridFilterBasicOperationsEnumeration) {
    GridFilterBasicOperationsEnumeration[GridFilterBasicOperationsEnumeration["And"] = 0] = "And";
    GridFilterBasicOperationsEnumeration[GridFilterBasicOperationsEnumeration["Or"] = 1] = "Or";
    GridFilterBasicOperationsEnumeration[GridFilterBasicOperationsEnumeration["Not"] = 2] = "Not";
})(GridFilterBasicOperationsEnumeration || (GridFilterBasicOperationsEnumeration = {}));
export var GridFilterWidthEnumeration;
(function (GridFilterWidthEnumeration) {
    GridFilterWidthEnumeration[GridFilterWidthEnumeration["XS"] = 0] = "XS";
    GridFilterWidthEnumeration[GridFilterWidthEnumeration["S"] = 1] = "S";
    GridFilterWidthEnumeration[GridFilterWidthEnumeration["M"] = 2] = "M";
    GridFilterWidthEnumeration[GridFilterWidthEnumeration["L"] = 3] = "L";
    GridFilterWidthEnumeration[GridFilterWidthEnumeration["XL"] = 4] = "XL";
})(GridFilterWidthEnumeration || (GridFilterWidthEnumeration = {}));
export var GridFilterComparisonEnumeration;
(function (GridFilterComparisonEnumeration) {
    GridFilterComparisonEnumeration[GridFilterComparisonEnumeration["Contains"] = 0] = "Contains";
    GridFilterComparisonEnumeration[GridFilterComparisonEnumeration["Equals"] = 1] = "Equals";
    GridFilterComparisonEnumeration[GridFilterComparisonEnumeration["Greater"] = 2] = "Greater";
    GridFilterComparisonEnumeration[GridFilterComparisonEnumeration["Less"] = 3] = "Less";
    GridFilterComparisonEnumeration[GridFilterComparisonEnumeration["GreaterOrEqual"] = 4] = "GreaterOrEqual";
    GridFilterComparisonEnumeration[GridFilterComparisonEnumeration["LessOrEqual"] = 5] = "LessOrEqual";
    GridFilterComparisonEnumeration[GridFilterComparisonEnumeration["StartsWith"] = 6] = "StartsWith";
    GridFilterComparisonEnumeration[GridFilterComparisonEnumeration["EndsWith"] = 7] = "EndsWith";
    GridFilterComparisonEnumeration[GridFilterComparisonEnumeration["NotEquals"] = 8] = "NotEquals";
    GridFilterComparisonEnumeration[GridFilterComparisonEnumeration["NotContains"] = 9] = "NotContains";
})(GridFilterComparisonEnumeration || (GridFilterComparisonEnumeration = {}));
export var GridFilterMethodEnumeration;
(function (GridFilterMethodEnumeration) {
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterAssetCommand"] = 0] = "GridFilterAssetCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterI18nCommand"] = 1] = "GridFilterI18nCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterI18nCustomerCommand"] = 2] = "GridFilterI18nCustomerCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterRmaCommand"] = 3] = "GridFilterRmaCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterUserCommand"] = 4] = "GridFilterUserCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterRoleCommand"] = 5] = "GridFilterRoleCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterAssetDefinitionCommand"] = 7] = "GridFilterAssetDefinitionCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterTenantAssetDefinitionCommand"] = 8] = "GridFilterTenantAssetDefinitionCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterAssetDefinitionSelectCommand"] = 9] = "GridFilterAssetDefinitionSelectCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["TreeFilterTenantCommand"] = 10] = "TreeFilterTenantCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterServiceContractCommand"] = 11] = "GridFilterServiceContractCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterAssetStatusGroupCommand"] = 21] = "GridFilterAssetStatusGroupCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterAssetTypeCommand"] = 22] = "GridFilterAssetTypeCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterManufacturerCommand"] = 26] = "GridFilterManufacturerCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterExchangePoolCommand"] = 27] = "GridFilterExchangePoolCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterServiceCenterCommand"] = 28] = "GridFilterServiceCenterCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterRepairCodeCommand"] = 30] = "GridFilterRepairCodeCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterSymptomCodeCommand"] = 31] = "GridFilterSymptomCodeCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterServiceCodeCommand"] = 32] = "GridFilterServiceCodeCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterRollInCommand"] = 33] = "GridFilterRollInCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterAssetCommandMinden"] = 34] = "GridFilterAssetCommandMinden";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterAssetHermesCommand"] = 35] = "GridFilterAssetHermesCommand";
    GridFilterMethodEnumeration[GridFilterMethodEnumeration["GridFilterLayoutCommand"] = 36] = "GridFilterLayoutCommand";
})(GridFilterMethodEnumeration || (GridFilterMethodEnumeration = {}));
export var GridFilterPropertyTypeEnumeration;
(function (GridFilterPropertyTypeEnumeration) {
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["String"] = 0] = "String";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["Boolean"] = 1] = "Boolean";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["Date"] = 2] = "Date";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["Time"] = 3] = "Time";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["DateTime"] = 4] = "DateTime";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["Number"] = 5] = "Number";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["Client"] = 6] = "Client";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["AssetDefinition"] = 7] = "AssetDefinition";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["Manufacturer"] = 8] = "Manufacturer";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["AssetType"] = 9] = "AssetType";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["AssetStatus"] = 10] = "AssetStatus";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["UserStatus"] = 11] = "UserStatus";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["Image"] = 12] = "Image";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["RmaStatus"] = 13] = "RmaStatus";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["DateRange"] = 14] = "DateRange";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["SymptomCodeGroup"] = 15] = "SymptomCodeGroup";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["RepairCodeGroup"] = 16] = "RepairCodeGroup";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["TenantHierarchy"] = 17] = "TenantHierarchy";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["Customer"] = 18] = "Customer";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["Permission"] = 19] = "Permission";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["Role"] = 20] = "Role";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["TranslationGroup"] = 21] = "TranslationGroup";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["StringSingle"] = 22] = "StringSingle";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["RollInStatus"] = 23] = "RollInStatus";
    GridFilterPropertyTypeEnumeration[GridFilterPropertyTypeEnumeration["RollInReason"] = 24] = "RollInReason";
})(GridFilterPropertyTypeEnumeration || (GridFilterPropertyTypeEnumeration = {}));
var GridFilterContextItem = /** @class */ (function () {
    function GridFilterContextItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterContextItem.prototype.init = function (data) {
        if (data) {
            this.context = data["context"] !== undefined ? data["context"] : null;
            this.condition = data["condition"] !== undefined ? data["condition"] : null;
        }
    };
    GridFilterContextItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterContextItem();
        result.init(data);
        return result;
    };
    GridFilterContextItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context !== undefined ? this.context : null;
        data["condition"] = this.condition !== undefined ? this.condition : null;
        return data;
    };
    return GridFilterContextItem;
}());
export { GridFilterContextItem };
var GridFilterParameters = /** @class */ (function () {
    function GridFilterParameters(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterParameters.prototype.init = function (data) {
        if (data) {
            this.reportContext = data["reportContext"] ? ReportContext.fromJS(data["reportContext"]) : null;
            this.treeFilter = data["treeFilter"] !== undefined ? data["treeFilter"] : null;
            if (data["orderBy"] && data["orderBy"].constructor === Array) {
                this.orderBy = [];
                for (var _i = 0, _a = data["orderBy"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.orderBy.push(GridFilterOrdering.fromJS(item));
                }
            }
            this.filter = data["filter"] !== undefined ? data["filter"] : null;
            this.gridFilterPaging = data["gridFilterPaging"] ? GridFilterPaging.fromJS(data["gridFilterPaging"]) : null;
            this.gridFilterExport = data["gridFilterExport"] !== undefined ? data["gridFilterExport"] : null;
            this.utcMinutesOffset = data["utcMinutesOffset"] !== undefined ? data["utcMinutesOffset"] : null;
            this.timeZoneIANA = data["timeZoneIANA"] !== undefined ? data["timeZoneIANA"] : null;
        }
    };
    GridFilterParameters.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterParameters();
        result.init(data);
        return result;
    };
    GridFilterParameters.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["reportContext"] = this.reportContext ? this.reportContext.toJSON() : null;
        data["treeFilter"] = this.treeFilter !== undefined ? this.treeFilter : null;
        if (this.orderBy && this.orderBy.constructor === Array) {
            data["orderBy"] = [];
            for (var _i = 0, _a = this.orderBy; _i < _a.length; _i++) {
                var item = _a[_i];
                data["orderBy"].push(item.toJSON());
            }
        }
        data["filter"] = this.filter !== undefined ? this.filter : null;
        data["gridFilterPaging"] = this.gridFilterPaging ? this.gridFilterPaging.toJSON() : null;
        data["gridFilterExport"] = this.gridFilterExport !== undefined ? this.gridFilterExport : null;
        data["utcMinutesOffset"] = this.utcMinutesOffset !== undefined ? this.utcMinutesOffset : null;
        data["timeZoneIANA"] = this.timeZoneIANA !== undefined ? this.timeZoneIANA : null;
        return data;
    };
    return GridFilterParameters;
}());
export { GridFilterParameters };
var ReportContext = /** @class */ (function () {
    function ReportContext(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.condition = "";
        }
    }
    ReportContext.prototype.init = function (data) {
        if (data) {
            this.condition = data["condition"] !== undefined ? data["condition"] : "";
            this.timeStamp = data["timeStamp"] ? new Date(data["timeStamp"].toString()) : null;
            this.assetTypeId = data["assetTypeId"] !== undefined ? data["assetTypeId"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            if (data["tenantIds"] && data["tenantIds"].constructor === Array) {
                this.tenantIds = [];
                for (var _i = 0, _a = data["tenantIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.tenantIds.push(item);
                }
            }
            if (data["rangeCollection"] && data["rangeCollection"].constructor === Array) {
                this.rangeCollection = [];
                for (var _b = 0, _c = data["rangeCollection"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.rangeCollection.push(ReportContextRange.fromJS(item));
                }
            }
        }
    };
    ReportContext.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReportContext();
        result.init(data);
        return result;
    };
    ReportContext.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["condition"] = this.condition !== undefined ? this.condition : null;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : null;
        data["assetTypeId"] = this.assetTypeId !== undefined ? this.assetTypeId : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        if (this.tenantIds && this.tenantIds.constructor === Array) {
            data["tenantIds"] = [];
            for (var _i = 0, _a = this.tenantIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["tenantIds"].push(item);
            }
        }
        if (this.rangeCollection && this.rangeCollection.constructor === Array) {
            data["rangeCollection"] = [];
            for (var _b = 0, _c = this.rangeCollection; _b < _c.length; _b++) {
                var item = _c[_b];
                data["rangeCollection"].push(item.toJSON());
            }
        }
        return data;
    };
    return ReportContext;
}());
export { ReportContext };
var ReportContextRange = /** @class */ (function () {
    function ReportContextRange(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.condition = "";
        }
    }
    ReportContextRange.prototype.init = function (data) {
        if (data) {
            this.condition = data["condition"] !== undefined ? data["condition"] : "";
            if (data["intervalls"] && data["intervalls"].constructor === Array) {
                this.intervalls = [];
                for (var _i = 0, _a = data["intervalls"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.intervalls.push(new Date(item));
                }
            }
        }
    };
    ReportContextRange.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReportContextRange();
        result.init(data);
        return result;
    };
    ReportContextRange.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["condition"] = this.condition !== undefined ? this.condition : null;
        if (this.intervalls && this.intervalls.constructor === Array) {
            data["intervalls"] = [];
            for (var _i = 0, _a = this.intervalls; _i < _a.length; _i++) {
                var item = _a[_i];
                data["intervalls"].push(item.toISOString());
            }
        }
        return data;
    };
    return ReportContextRange;
}());
export { ReportContextRange };
var GridFilterOrdering = /** @class */ (function () {
    function GridFilterOrdering(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.sequence = SequenceEnum.ASC;
        }
    }
    GridFilterOrdering.prototype.init = function (data) {
        if (data) {
            this.value = data["value"] !== undefined ? data["value"] : null;
            this.sequence = data["sequence"] !== undefined ? data["sequence"] : null;
        }
    };
    GridFilterOrdering.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterOrdering();
        result.init(data);
        return result;
    };
    GridFilterOrdering.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : null;
        data["sequence"] = this.sequence !== undefined ? this.sequence : null;
        return data;
    };
    return GridFilterOrdering;
}());
export { GridFilterOrdering };
export var SequenceEnum;
(function (SequenceEnum) {
    SequenceEnum[SequenceEnum["ASC"] = 0] = "ASC";
    SequenceEnum[SequenceEnum["DESC"] = 1] = "DESC";
})(SequenceEnum || (SequenceEnum = {}));
var GridFilterPaging = /** @class */ (function () {
    function GridFilterPaging(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.skip = 0;
            this.take = 2147483647;
        }
    }
    GridFilterPaging.prototype.init = function (data) {
        if (data) {
            this.skip = data["skip"] !== undefined ? data["skip"] : 0;
            this.take = data["take"] !== undefined ? data["take"] : 2147483647;
        }
    };
    GridFilterPaging.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterPaging();
        result.init(data);
        return result;
    };
    GridFilterPaging.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["skip"] = this.skip !== undefined ? this.skip : null;
        data["take"] = this.take !== undefined ? this.take : null;
        return data;
    };
    return GridFilterPaging;
}());
export { GridFilterPaging };
var GridFilterPosition = /** @class */ (function () {
    function GridFilterPosition(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterPosition.prototype.init = function (data) {
        if (data) {
            this.lat = data["lat"] !== undefined ? data["lat"] : null;
            this.lon = data["lon"] !== undefined ? data["lon"] : null;
            this.timeStamp = data["timeStamp"] ? new Date(data["timeStamp"].toString()) : null;
        }
    };
    GridFilterPosition.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterPosition();
        result.init(data);
        return result;
    };
    GridFilterPosition.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["lat"] = this.lat !== undefined ? this.lat : null;
        data["lon"] = this.lon !== undefined ? this.lon : null;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : null;
        return data;
    };
    return GridFilterPosition;
}());
export { GridFilterPosition };
var GridFilterRequest = /** @class */ (function () {
    function GridFilterRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterRequest.prototype.init = function (data) {
        if (data) {
            this.method = data["method"] !== undefined ? data["method"] : null;
            this.params = data["params"] ? GridFilterParameters.fromJS(data["params"]) : null;
            this.id = data["id"] !== undefined ? data["id"] : null;
        }
    };
    GridFilterRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterRequest();
        result.init(data);
        return result;
    };
    GridFilterRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method !== undefined ? this.method : null;
        data["params"] = this.params ? this.params.toJSON() : null;
        data["id"] = this.id !== undefined ? this.id : null;
        return data;
    };
    return GridFilterRequest;
}());
export { GridFilterRequest };
var GridFilterResponse = /** @class */ (function () {
    function GridFilterResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterResponse.prototype.init = function (data) {
        if (data) {
            if (data["result"] && data["result"].constructor === Array) {
                this.result = [];
                for (var _i = 0, _a = data["result"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.result.push(item);
                }
            }
            this.total = data["total"] !== undefined ? data["total"] : null;
            this.error = data["error"] ? GridFilterResponseError.fromJS(data["error"]) : null;
            this.id = data["id"] !== undefined ? data["id"] : null;
            this.method = data["method"] !== undefined ? data["method"] : null;
            this.exportType = data["exportType"] !== undefined ? data["exportType"] : null;
            this.utcMinutesOffset = data["utcMinutesOffset"] !== undefined ? data["utcMinutesOffset"] : null;
            this.timeZoneIANA = data["timeZoneIANA"] !== undefined ? data["timeZoneIANA"] : null;
        }
    };
    GridFilterResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterResponse();
        result.init(data);
        return result;
    };
    GridFilterResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.result && this.result.constructor === Array) {
            data["result"] = [];
            for (var _i = 0, _a = this.result; _i < _a.length; _i++) {
                var item = _a[_i];
                data["result"].push(item);
            }
        }
        data["total"] = this.total !== undefined ? this.total : null;
        data["error"] = this.error ? this.error.toJSON() : null;
        data["id"] = this.id !== undefined ? this.id : null;
        data["method"] = this.method !== undefined ? this.method : null;
        data["exportType"] = this.exportType !== undefined ? this.exportType : null;
        data["utcMinutesOffset"] = this.utcMinutesOffset !== undefined ? this.utcMinutesOffset : null;
        data["timeZoneIANA"] = this.timeZoneIANA !== undefined ? this.timeZoneIANA : null;
        return data;
    };
    return GridFilterResponse;
}());
export { GridFilterResponse };
var GridFilterResponseError = /** @class */ (function () {
    function GridFilterResponseError(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterResponseError.prototype.init = function (data) {
        if (data) {
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.message = data["message"] !== undefined ? data["message"] : null;
            if (data["data"]) {
                this.data = {};
                for (var key in data["data"]) {
                    if (data["data"].hasOwnProperty(key))
                        this.data[key] = data["data"][key];
                }
            }
            this.additionalInfo = data["additionalInfo"] !== undefined ? data["additionalInfo"] : null;
        }
    };
    GridFilterResponseError.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterResponseError();
        result.init(data);
        return result;
    };
    GridFilterResponseError.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null;
        data["message"] = this.message !== undefined ? this.message : null;
        if (this.data) {
            data["data"] = {};
            for (var key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key] !== undefined ? this.data[key] : null;
            }
        }
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : null;
        return data;
    };
    return GridFilterResponseError;
}());
export { GridFilterResponseError };
var GridFilterRequestPropertiesViewModel = /** @class */ (function () {
    function GridFilterRequestPropertiesViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridFilterRequestPropertiesViewModel.prototype.init = function (data) {
        if (data) {
            if (data["columns"] && data["columns"].constructor === Array) {
                this.columns = [];
                for (var _i = 0, _a = data["columns"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.columns.push(Column.fromJS(item));
                }
            }
        }
    };
    GridFilterRequestPropertiesViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterRequestPropertiesViewModel();
        result.init(data);
        return result;
    };
    GridFilterRequestPropertiesViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.columns && this.columns.constructor === Array) {
            data["columns"] = [];
            for (var _i = 0, _a = this.columns; _i < _a.length; _i++) {
                var item = _a[_i];
                data["columns"].push(item.toJSON());
            }
        }
        return data;
    };
    return GridFilterRequestPropertiesViewModel;
}());
export { GridFilterRequestPropertiesViewModel };
var Column = /** @class */ (function () {
    function Column(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Column.prototype.init = function (data) {
        if (data) {
            this.width = data["width"] !== undefined ? data["width"] : null;
            this.propertyType = data["propertyType"] !== undefined ? data["propertyType"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.property = data["property"] !== undefined ? data["property"] : null;
            this.isPrimaryKey = data["isPrimaryKey"] !== undefined ? data["isPrimaryKey"] : null;
            if (data["comparisons"] && data["comparisons"].constructor === Array) {
                this.comparisons = [];
                for (var _i = 0, _a = data["comparisons"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.comparisons.push(item);
                }
            }
            this.activeView = data["activeView"] !== undefined ? data["activeView"] : null;
            this.activeSort = data["activeSort"] !== undefined ? data["activeSort"] : null;
            this.activeSearch = data["activeSearch"] !== undefined ? data["activeSearch"] : null;
            this.orderId = data["orderId"] !== undefined ? data["orderId"] : null;
            this.propertyName = data["propertyName"] !== undefined ? data["propertyName"] : null;
            this.hideOnDefault = data["hideOnDefault"] !== undefined ? data["hideOnDefault"] : null;
            if (data["concatProperties"] && data["concatProperties"].constructor === Array) {
                this.concatProperties = [];
                for (var _b = 0, _c = data["concatProperties"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.concatProperties.push(item);
                }
            }
            this.concatSeparator = data["concatSeparator"] !== undefined ? data["concatSeparator"] : null;
            this.dataSourceCaseSensitiveCollation = data["dataSourceCaseSensitiveCollation"] !== undefined ? data["dataSourceCaseSensitiveCollation"] : null;
        }
    };
    Column.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Column();
        result.init(data);
        return result;
    };
    Column.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width !== undefined ? this.width : null;
        data["propertyType"] = this.propertyType !== undefined ? this.propertyType : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["property"] = this.property !== undefined ? this.property : null;
        data["isPrimaryKey"] = this.isPrimaryKey !== undefined ? this.isPrimaryKey : null;
        if (this.comparisons && this.comparisons.constructor === Array) {
            data["comparisons"] = [];
            for (var _i = 0, _a = this.comparisons; _i < _a.length; _i++) {
                var item = _a[_i];
                data["comparisons"].push(item);
            }
        }
        data["activeView"] = this.activeView !== undefined ? this.activeView : null;
        data["activeSort"] = this.activeSort !== undefined ? this.activeSort : null;
        data["activeSearch"] = this.activeSearch !== undefined ? this.activeSearch : null;
        data["orderId"] = this.orderId !== undefined ? this.orderId : null;
        data["propertyName"] = this.propertyName !== undefined ? this.propertyName : null;
        data["hideOnDefault"] = this.hideOnDefault !== undefined ? this.hideOnDefault : null;
        if (this.concatProperties && this.concatProperties.constructor === Array) {
            data["concatProperties"] = [];
            for (var _b = 0, _c = this.concatProperties; _b < _c.length; _b++) {
                var item = _c[_b];
                data["concatProperties"].push(item);
            }
        }
        data["concatSeparator"] = this.concatSeparator !== undefined ? this.concatSeparator : null;
        data["dataSourceCaseSensitiveCollation"] = this.dataSourceCaseSensitiveCollation !== undefined ? this.dataSourceCaseSensitiveCollation : null;
        return data;
    };
    return Column;
}());
export { Column };
var Attribute = /** @class */ (function () {
    function Attribute(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Attribute.prototype.init = function (data) {
        if (data) {
            this.typeId = data["typeId"] !== undefined ? data["typeId"] : null;
        }
    };
    Attribute.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Attribute' cannot be instantiated.");
    };
    Attribute.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId !== undefined ? this.typeId : null;
        return data;
    };
    return Attribute;
}());
export { Attribute };
var GridFilterColumnAttributeAttribute = /** @class */ (function (_super) {
    __extends(GridFilterColumnAttributeAttribute, _super);
    function GridFilterColumnAttributeAttribute(data) {
        return _super.call(this, data) || this;
    }
    GridFilterColumnAttributeAttribute.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            if (data["comparisons"] && data["comparisons"].constructor === Array) {
                this.comparisons = [];
                for (var _i = 0, _a = data["comparisons"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.comparisons.push(item);
                }
            }
            this.property = data["property"] !== undefined ? data["property"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.selectorType = data["selectorType"] !== undefined ? data["selectorType"] : null;
            this.properType = data["properType"] !== undefined ? data["properType"] : null;
            this.width = data["width"] !== undefined ? data["width"] : null;
            this.activeView = data["activeView"] !== undefined ? data["activeView"] : null;
            this.activeSearch = data["activeSearch"] !== undefined ? data["activeSearch"] : null;
            this.activeSort = data["activeSort"] !== undefined ? data["activeSort"] : null;
            this.orderId = data["orderId"] !== undefined ? data["orderId"] : null;
            if (data["concatProperties"] && data["concatProperties"].constructor === Array) {
                this.concatProperties = [];
                for (var _b = 0, _c = data["concatProperties"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.concatProperties.push(item);
                }
            }
            this.concatSeparator = data["concatSeparator"] !== undefined ? data["concatSeparator"] : null;
            this.isPrimaryKey = data["isPrimaryKey"] !== undefined ? data["isPrimaryKey"] : null;
            this.hideOnDefault = data["hideOnDefault"] !== undefined ? data["hideOnDefault"] : null;
            this.dataSourceCaseSensitiveCollation = data["dataSourceCaseSensitiveCollation"] !== undefined ? data["dataSourceCaseSensitiveCollation"] : null;
        }
    };
    GridFilterColumnAttributeAttribute.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridFilterColumnAttributeAttribute();
        result.init(data);
        return result;
    };
    GridFilterColumnAttributeAttribute.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.comparisons && this.comparisons.constructor === Array) {
            data["comparisons"] = [];
            for (var _i = 0, _a = this.comparisons; _i < _a.length; _i++) {
                var item = _a[_i];
                data["comparisons"].push(item);
            }
        }
        data["property"] = this.property !== undefined ? this.property : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["selectorType"] = this.selectorType !== undefined ? this.selectorType : null;
        data["properType"] = this.properType !== undefined ? this.properType : null;
        data["width"] = this.width !== undefined ? this.width : null;
        data["activeView"] = this.activeView !== undefined ? this.activeView : null;
        data["activeSearch"] = this.activeSearch !== undefined ? this.activeSearch : null;
        data["activeSort"] = this.activeSort !== undefined ? this.activeSort : null;
        data["orderId"] = this.orderId !== undefined ? this.orderId : null;
        if (this.concatProperties && this.concatProperties.constructor === Array) {
            data["concatProperties"] = [];
            for (var _b = 0, _c = this.concatProperties; _b < _c.length; _b++) {
                var item = _c[_b];
                data["concatProperties"].push(item);
            }
        }
        data["concatSeparator"] = this.concatSeparator !== undefined ? this.concatSeparator : null;
        data["isPrimaryKey"] = this.isPrimaryKey !== undefined ? this.isPrimaryKey : null;
        data["hideOnDefault"] = this.hideOnDefault !== undefined ? this.hideOnDefault : null;
        data["dataSourceCaseSensitiveCollation"] = this.dataSourceCaseSensitiveCollation !== undefined ? this.dataSourceCaseSensitiveCollation : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return GridFilterColumnAttributeAttribute;
}(Attribute));
export { GridFilterColumnAttributeAttribute };
var TenantTreeViewViewModel = /** @class */ (function () {
    function TenantTreeViewViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantTreeViewViewModel.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.level = data["level"] !== undefined ? data["level"] : null;
            this.hasConditionalChildren = data["hasConditionalChildren"] !== undefined ? data["hasConditionalChildren"] : null;
            this.zipCode = data["zipCode"] !== undefined ? data["zipCode"] : null;
            this.city = data["city"] !== undefined ? data["city"] : null;
            this.companyName = data["companyName"] !== undefined ? data["companyName"] : null;
            this.tenantType = data["tenantType"] !== undefined ? data["tenantType"] : null;
        }
    };
    TenantTreeViewViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantTreeViewViewModel();
        result.init(data);
        return result;
    };
    TenantTreeViewViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["level"] = this.level !== undefined ? this.level : null;
        data["hasConditionalChildren"] = this.hasConditionalChildren !== undefined ? this.hasConditionalChildren : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["city"] = this.city !== undefined ? this.city : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["tenantType"] = this.tenantType !== undefined ? this.tenantType : null;
        return data;
    };
    return TenantTreeViewViewModel;
}());
export { TenantTreeViewViewModel };
var AssetDefinitionSelectViewModel = /** @class */ (function () {
    function AssetDefinitionSelectViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AssetDefinitionSelectViewModel.prototype.init = function (data) {
        if (data) {
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.assetType = data["assetType"] !== undefined ? data["assetType"] : null;
        }
    };
    AssetDefinitionSelectViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AssetDefinitionSelectViewModel();
        result.init(data);
        return result;
    };
    AssetDefinitionSelectViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["assetType"] = this.assetType !== undefined ? this.assetType : null;
        return data;
    };
    return AssetDefinitionSelectViewModel;
}());
export { AssetDefinitionSelectViewModel };
export var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["DefectDeviceDeliveryNote"] = 1] = "DefectDeviceDeliveryNote";
    DocumentType[DocumentType["ExchangeDeviceDeliveryNote"] = 2] = "ExchangeDeviceDeliveryNote";
    DocumentType[DocumentType["RepairedDeviceDeliveryNote"] = 3] = "RepairedDeviceDeliveryNote";
    DocumentType[DocumentType["DefectDeviceCollectiveDeliveryNote"] = 4] = "DefectDeviceCollectiveDeliveryNote";
    DocumentType[DocumentType["ReclamationDeliveryNote"] = 5] = "ReclamationDeliveryNote";
    DocumentType[DocumentType["RepairCenterImportErrorNotification"] = 6] = "RepairCenterImportErrorNotification";
    DocumentType[DocumentType["RepairCenterImportReport"] = 7] = "RepairCenterImportReport";
    DocumentType[DocumentType["RepairCenterImportValidationErrorNotification"] = 8] = "RepairCenterImportValidationErrorNotification";
    DocumentType[DocumentType["ExchangeNotificationEmail"] = 9] = "ExchangeNotificationEmail";
    DocumentType[DocumentType["RepairCenterNotificationEmail"] = 10] = "RepairCenterNotificationEmail";
    DocumentType[DocumentType["SendungsDaten"] = 11] = "SendungsDaten";
    DocumentType[DocumentType["RmaServiceOverview"] = 12] = "RmaServiceOverview";
    DocumentType[DocumentType["RmaServiceRepaired"] = 13] = "RmaServiceRepaired";
    DocumentType[DocumentType["RmaServiceClosed"] = 14] = "RmaServiceClosed";
    DocumentType[DocumentType["RmaServiceExchanged"] = 15] = "RmaServiceExchanged";
    DocumentType[DocumentType["RmaShippmentLabel"] = 16] = "RmaShippmentLabel";
    DocumentType[DocumentType["AdminNotice"] = 17] = "AdminNotice";
    DocumentType[DocumentType["UserAccountCreatedEmail"] = 18] = "UserAccountCreatedEmail";
    DocumentType[DocumentType["UserPaswordResetRequestEmail"] = 19] = "UserPaswordResetRequestEmail";
    DocumentType[DocumentType["RepairedAssetShipped"] = 20] = "RepairedAssetShipped";
    DocumentType[DocumentType["RmaExchangeShippmentLabel"] = 21] = "RmaExchangeShippmentLabel";
    DocumentType[DocumentType["RollInTaskDeliveryNote"] = 22] = "RollInTaskDeliveryNote";
})(DocumentType || (DocumentType = {}));
var Manufacturer = /** @class */ (function () {
    function Manufacturer(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Manufacturer.prototype.init = function (data) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
        }
    };
    Manufacturer.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Manufacturer();
        result.init(data);
        return result;
    };
    Manufacturer.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["name"] = this.name !== undefined ? this.name : null;
        return data;
    };
    return Manufacturer;
}());
export { Manufacturer };
export var ExternalSystems;
(function (ExternalSystems) {
    ExternalSystems[ExternalSystems["None"] = 0] = "None";
    ExternalSystems[ExternalSystems["Tesma"] = 1] = "Tesma";
    ExternalSystems[ExternalSystems["SOTI"] = 2] = "SOTI";
})(ExternalSystems || (ExternalSystems = {}));
export var DataDocumentType;
(function (DataDocumentType) {
    DataDocumentType[DataDocumentType["AssetDefinition"] = 0] = "AssetDefinition";
    DataDocumentType[DataDocumentType["TenantAssetDefinition"] = 1] = "TenantAssetDefinition";
    DataDocumentType[DataDocumentType["Tenant"] = 2] = "Tenant";
    DataDocumentType[DataDocumentType["ServiceContract"] = 3] = "ServiceContract";
})(DataDocumentType || (DataDocumentType = {}));
export var ActionsEnumeration;
(function (ActionsEnumeration) {
    ActionsEnumeration[ActionsEnumeration["CanExchange"] = 0] = "CanExchange";
    ActionsEnumeration[ActionsEnumeration["CanSendExchange"] = 1] = "CanSendExchange";
    ActionsEnumeration[ActionsEnumeration["CanCheckDevice"] = 2] = "CanCheckDevice";
    ActionsEnumeration[ActionsEnumeration["CanRepairDevice"] = 3] = "CanRepairDevice";
    ActionsEnumeration[ActionsEnumeration["CanPostRepair"] = 4] = "CanPostRepair";
    ActionsEnumeration[ActionsEnumeration["CanConfirmReceivingDevice"] = 5] = "CanConfirmReceivingDevice";
    ActionsEnumeration[ActionsEnumeration["CanSendRepair"] = 6] = "CanSendRepair";
    ActionsEnumeration[ActionsEnumeration["CanRevoke"] = 7] = "CanRevoke";
    ActionsEnumeration[ActionsEnumeration["CanChangeAsset"] = 8] = "CanChangeAsset";
    ActionsEnumeration[ActionsEnumeration["CanConfirmIntactAssetReceived"] = 9] = "CanConfirmIntactAssetReceived";
})(ActionsEnumeration || (ActionsEnumeration = {}));
var Document = /** @class */ (function () {
    function Document(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Document.prototype.init = function (data) {
        if (data) {
            this.contentType = data["contentType"] !== undefined ? data["contentType"] : null;
            this.container = data["container"] !== undefined ? data["container"] : null;
            this.virtualFolderPath = data["virtualFolderPath"] !== undefined ? data["virtualFolderPath"] : null;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : null;
            this.documentName = data["documentName"] !== undefined ? data["documentName"] : null;
            this.documentDescription = data["documentDescription"] !== undefined ? data["documentDescription"] : null;
            this.dataDocumentType = data["dataDocumentType"] !== undefined ? data["dataDocumentType"] : null;
        }
    };
    Document.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Document();
        result.init(data);
        return result;
    };
    Document.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType !== undefined ? this.contentType : null;
        data["container"] = this.container !== undefined ? this.container : null;
        data["virtualFolderPath"] = this.virtualFolderPath !== undefined ? this.virtualFolderPath : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["documentName"] = this.documentName !== undefined ? this.documentName : null;
        data["documentDescription"] = this.documentDescription !== undefined ? this.documentDescription : null;
        data["dataDocumentType"] = this.dataDocumentType !== undefined ? this.dataDocumentType : null;
        return data;
    };
    return Document;
}());
export { Document };
var HttpStatusCodeAttribute = /** @class */ (function (_super) {
    __extends(HttpStatusCodeAttribute, _super);
    function HttpStatusCodeAttribute(data) {
        return _super.call(this, data) || this;
    }
    HttpStatusCodeAttribute.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            this.code = data["code"] !== undefined ? data["code"] : null;
        }
    };
    HttpStatusCodeAttribute.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HttpStatusCodeAttribute();
        result.init(data);
        return result;
    };
    HttpStatusCodeAttribute.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return HttpStatusCodeAttribute;
}(Attribute));
export { HttpStatusCodeAttribute };
export var HttpStatusCode;
(function (HttpStatusCode) {
    HttpStatusCode[HttpStatusCode["Continue"] = 100] = "Continue";
    HttpStatusCode[HttpStatusCode["SwitchingProtocols"] = 101] = "SwitchingProtocols";
    HttpStatusCode[HttpStatusCode["OK"] = 200] = "OK";
    HttpStatusCode[HttpStatusCode["Created"] = 201] = "Created";
    HttpStatusCode[HttpStatusCode["Accepted"] = 202] = "Accepted";
    HttpStatusCode[HttpStatusCode["NonAuthoritativeInformation"] = 203] = "NonAuthoritativeInformation";
    HttpStatusCode[HttpStatusCode["NoContent"] = 204] = "NoContent";
    HttpStatusCode[HttpStatusCode["ResetContent"] = 205] = "ResetContent";
    HttpStatusCode[HttpStatusCode["PartialContent"] = 206] = "PartialContent";
    HttpStatusCode[HttpStatusCode["MultipleChoices"] = 300] = "MultipleChoices";
    HttpStatusCode[HttpStatusCode["Ambiguous"] = 300] = "Ambiguous";
    HttpStatusCode[HttpStatusCode["MovedPermanently"] = 301] = "MovedPermanently";
    HttpStatusCode[HttpStatusCode["Moved"] = 301] = "Moved";
    HttpStatusCode[HttpStatusCode["Found"] = 302] = "Found";
    HttpStatusCode[HttpStatusCode["Redirect"] = 302] = "Redirect";
    HttpStatusCode[HttpStatusCode["SeeOther"] = 303] = "SeeOther";
    HttpStatusCode[HttpStatusCode["RedirectMethod"] = 303] = "RedirectMethod";
    HttpStatusCode[HttpStatusCode["NotModified"] = 304] = "NotModified";
    HttpStatusCode[HttpStatusCode["UseProxy"] = 305] = "UseProxy";
    HttpStatusCode[HttpStatusCode["Unused"] = 306] = "Unused";
    HttpStatusCode[HttpStatusCode["TemporaryRedirect"] = 307] = "TemporaryRedirect";
    HttpStatusCode[HttpStatusCode["RedirectKeepVerb"] = 307] = "RedirectKeepVerb";
    HttpStatusCode[HttpStatusCode["BadRequest"] = 400] = "BadRequest";
    HttpStatusCode[HttpStatusCode["Unauthorized"] = 401] = "Unauthorized";
    HttpStatusCode[HttpStatusCode["PaymentRequired"] = 402] = "PaymentRequired";
    HttpStatusCode[HttpStatusCode["Forbidden"] = 403] = "Forbidden";
    HttpStatusCode[HttpStatusCode["NotFound"] = 404] = "NotFound";
    HttpStatusCode[HttpStatusCode["MethodNotAllowed"] = 405] = "MethodNotAllowed";
    HttpStatusCode[HttpStatusCode["NotAcceptable"] = 406] = "NotAcceptable";
    HttpStatusCode[HttpStatusCode["ProxyAuthenticationRequired"] = 407] = "ProxyAuthenticationRequired";
    HttpStatusCode[HttpStatusCode["RequestTimeout"] = 408] = "RequestTimeout";
    HttpStatusCode[HttpStatusCode["Conflict"] = 409] = "Conflict";
    HttpStatusCode[HttpStatusCode["Gone"] = 410] = "Gone";
    HttpStatusCode[HttpStatusCode["LengthRequired"] = 411] = "LengthRequired";
    HttpStatusCode[HttpStatusCode["PreconditionFailed"] = 412] = "PreconditionFailed";
    HttpStatusCode[HttpStatusCode["RequestEntityTooLarge"] = 413] = "RequestEntityTooLarge";
    HttpStatusCode[HttpStatusCode["RequestUriTooLong"] = 414] = "RequestUriTooLong";
    HttpStatusCode[HttpStatusCode["UnsupportedMediaType"] = 415] = "UnsupportedMediaType";
    HttpStatusCode[HttpStatusCode["RequestedRangeNotSatisfiable"] = 416] = "RequestedRangeNotSatisfiable";
    HttpStatusCode[HttpStatusCode["ExpectationFailed"] = 417] = "ExpectationFailed";
    HttpStatusCode[HttpStatusCode["UpgradeRequired"] = 426] = "UpgradeRequired";
    HttpStatusCode[HttpStatusCode["InternalServerError"] = 500] = "InternalServerError";
    HttpStatusCode[HttpStatusCode["NotImplemented"] = 501] = "NotImplemented";
    HttpStatusCode[HttpStatusCode["BadGateway"] = 502] = "BadGateway";
    HttpStatusCode[HttpStatusCode["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    HttpStatusCode[HttpStatusCode["GatewayTimeout"] = 504] = "GatewayTimeout";
    HttpStatusCode[HttpStatusCode["HttpVersionNotSupported"] = 505] = "HttpVersionNotSupported";
})(HttpStatusCode || (HttpStatusCode = {}));
export var ValidationError;
(function (ValidationError) {
    ValidationError[ValidationError["PasswordNotComplexEnough"] = 0] = "PasswordNotComplexEnough";
    ValidationError[ValidationError["CanNotReusePassword"] = 1] = "CanNotReusePassword";
    ValidationError[ValidationError["PasswordCantContainUsername"] = 2] = "PasswordCantContainUsername";
    ValidationError[ValidationError["CantConnectToFileStorage"] = 3] = "CantConnectToFileStorage";
    ValidationError[ValidationError["AssetStatusCodeGroupDoesntExist"] = 4] = "AssetStatusCodeGroupDoesntExist";
    ValidationError[ValidationError["CantMoveDevicesBetweenClients"] = 5] = "CantMoveDevicesBetweenClients";
    ValidationError[ValidationError["AssetNotReadyForBundling"] = 6] = "AssetNotReadyForBundling";
    ValidationError[ValidationError["AssetNotOnLocation"] = 7] = "AssetNotOnLocation";
    ValidationError[ValidationError["ExchangePoolWithIdNotFound"] = 8] = "ExchangePoolWithIdNotFound";
    ValidationError[ValidationError["ServiceCenterIsNotPartOfNetwork"] = 9] = "ServiceCenterIsNotPartOfNetwork";
    ValidationError[ValidationError["ServiceProviderIsAttachedToCustomermodels"] = 10] = "ServiceProviderIsAttachedToCustomermodels";
    ValidationError[ValidationError["AssetIsNotInSourceLocation"] = 11] = "AssetIsNotInSourceLocation";
    ValidationError[ValidationError["ServiceContractIsNotPartOfNetwork"] = 12] = "ServiceContractIsNotPartOfNetwork";
    ValidationError[ValidationError["AssetDefinitionDoesNotExist"] = 13] = "AssetDefinitionDoesNotExist";
    ValidationError[ValidationError["AssetInRma"] = 14] = "AssetInRma";
    ValidationError[ValidationError["NoSenderAddressProvided"] = 15] = "NoSenderAddressProvided";
    ValidationError[ValidationError["NoReceiverAddressProvided"] = 16] = "NoReceiverAddressProvided";
    ValidationError[ValidationError["TenantIsNotPartOfNetwork"] = 17] = "TenantIsNotPartOfNetwork";
    ValidationError[ValidationError["AssetIsInExchangePool"] = 18] = "AssetIsInExchangePool";
    ValidationError[ValidationError["Empty"] = 19] = "Empty";
    ValidationError[ValidationError["EnumError"] = 20] = "EnumError";
    ValidationError[ValidationError["DeviceDefinitionDoesNotMatch"] = 21] = "DeviceDefinitionDoesNotMatch";
    ValidationError[ValidationError["Equal"] = 22] = "Equal";
    ValidationError[ValidationError["ExactLength"] = 23] = "ExactLength";
    ValidationError[ValidationError["ExclusiveBetween"] = 24] = "ExclusiveBetween";
    ValidationError[ValidationError["GreaterThan"] = 25] = "GreaterThan";
    ValidationError[ValidationError["GreaterThanOrEqual"] = 26] = "GreaterThanOrEqual";
    ValidationError[ValidationError["InclusiveBetween"] = 27] = "InclusiveBetween";
    ValidationError[ValidationError["Length"] = 28] = "Length";
    ValidationError[ValidationError["LessThan"] = 29] = "LessThan";
    ValidationError[ValidationError["LessThanOrEqual"] = 30] = "LessThanOrEqual";
    ValidationError[ValidationError["NotEmpty"] = 31] = "NotEmpty";
    ValidationError[ValidationError["NotEqual"] = 32] = "NotEqual";
    ValidationError[ValidationError["NotNull"] = 33] = "NotNull";
    ValidationError[ValidationError["NullError"] = 34] = "NullError";
    ValidationError[ValidationError["Predicate"] = 35] = "Predicate";
    ValidationError[ValidationError["Regex"] = 36] = "Regex";
    ValidationError[ValidationError["ScalePrecision"] = 37] = "ScalePrecision";
    ValidationError[ValidationError["RepairCodeCategoryCanNotBeFound"] = 38] = "RepairCodeCategoryCanNotBeFound";
    ValidationError[ValidationError["CanNotResetPasswordForTransientUser"] = 39] = "CanNotResetPasswordForTransientUser";
    ValidationError[ValidationError["CanNotDisableTransientUser"] = 40] = "CanNotDisableTransientUser";
    ValidationError[ValidationError["CanNotDeactivateTransientUser"] = 41] = "CanNotDeactivateTransientUser";
    ValidationError[ValidationError["CanSetPasswordOnlyOnTemporaryAuthorization"] = 42] = "CanSetPasswordOnlyOnTemporaryAuthorization";
    ValidationError[ValidationError["AssetWithIDNotFound"] = 43] = "AssetWithIDNotFound";
    ValidationError[ValidationError["AssetWithSerialNumberNotFound"] = 44] = "AssetWithSerialNumberNotFound";
    ValidationError[ValidationError["RmaWithIdNotFound"] = 45] = "RmaWithIdNotFound";
    ValidationError[ValidationError["AssetWithSerialNumberForTheModelNotFound"] = 46] = "AssetWithSerialNumberForTheModelNotFound";
    ValidationError[ValidationError["AssetAccessoryNotInSameLocation"] = 47] = "AssetAccessoryNotInSameLocation";
    ValidationError[ValidationError["AccessDeniedForProperty"] = 48] = "AccessDeniedForProperty";
    ValidationError[ValidationError["TenantForAssetNotFound"] = 49] = "TenantForAssetNotFound";
    ValidationError[ValidationError["TenantWithSameNameAlreadyExists"] = 50] = "TenantWithSameNameAlreadyExists";
    ValidationError[ValidationError["ErrorInTenantHierarchy"] = 51] = "ErrorInTenantHierarchy";
    ValidationError[ValidationError["AssetModelNotAssignedToLocation"] = 52] = "AssetModelNotAssignedToLocation";
    ValidationError[ValidationError["InvalidOperation"] = 53] = "InvalidOperation";
    ValidationError[ValidationError["CanNotGenerateRMAForAssetThatIsAlreadyActiveInRma"] = 54] = "CanNotGenerateRMAForAssetThatIsAlreadyActiveInRma";
    ValidationError[ValidationError["AtLeastOneSymptomCodeMustBeSelected"] = 55] = "AtLeastOneSymptomCodeMustBeSelected";
    ValidationError[ValidationError["TheUserLanguageMustBeSet"] = 56] = "TheUserLanguageMustBeSet";
    ValidationError[ValidationError["SymptomCodeInvalidForAsset"] = 57] = "SymptomCodeInvalidForAsset";
    ValidationError[ValidationError["RepairCodeInvalidForAsset"] = 58] = "RepairCodeInvalidForAsset";
    ValidationError[ValidationError["MissingRepairCode"] = 59] = "MissingRepairCode";
    ValidationError[ValidationError["RmaWithIDDoesNotExist"] = 60] = "RmaWithIDDoesNotExist";
    ValidationError[ValidationError["TheFeatureDoesNotExistInModule"] = 61] = "TheFeatureDoesNotExistInModule";
    ValidationError[ValidationError["AccessoryDoesNotExistForAssetWithID"] = 62] = "AccessoryDoesNotExistForAssetWithID";
    ValidationError[ValidationError["AccessoryAlreadyInRma"] = 63] = "AccessoryAlreadyInRma";
    ValidationError[ValidationError["AssetAlreadyInRma"] = 64] = "AssetAlreadyInRma";
    ValidationError[ValidationError["BundleContentDoesNotExistForAssetWithID"] = 65] = "BundleContentDoesNotExistForAssetWithID";
    ValidationError[ValidationError["BundleContentExistForAssetWithID"] = 66] = "BundleContentExistForAssetWithID";
    ValidationError[ValidationError["BundleContentDefinitionDoesNotExistForAssetWithID"] = 67] = "BundleContentDefinitionDoesNotExistForAssetWithID";
    ValidationError[ValidationError["BundleContainsMultipleBundleDefinitions"] = 68] = "BundleContainsMultipleBundleDefinitions";
    ValidationError[ValidationError["BundleContainsMultipleInstancesOfAModel"] = 69] = "BundleContainsMultipleInstancesOfAModel";
    ValidationError[ValidationError["CanNotDisableCoreModule"] = 70] = "CanNotDisableCoreModule";
    ValidationError[ValidationError["CanNotEnableFeatureModuleIsNotEnabled"] = 71] = "CanNotEnableFeatureModuleIsNotEnabled";
    ValidationError[ValidationError["CanNotEnableFeatureModuleDoesNotContainFeature"] = 72] = "CanNotEnableFeatureModuleDoesNotContainFeature";
    ValidationError[ValidationError["CanNotDisableFeatureModuleIsNotEnabled"] = 73] = "CanNotDisableFeatureModuleIsNotEnabled";
    ValidationError[ValidationError["CanNotDisableFeatureModuleDoesNotContainFeature"] = 74] = "CanNotDisableFeatureModuleDoesNotContainFeature";
    ValidationError[ValidationError["CanNotDisableFeatureItIsCoreFeatureOfModule"] = 75] = "CanNotDisableFeatureItIsCoreFeatureOfModule";
    ValidationError[ValidationError["ParentTenantWithIDDoesNotExist"] = 76] = "ParentTenantWithIDDoesNotExist";
    ValidationError[ValidationError["ChildTenantWithIDDoesNotExist"] = 77] = "ChildTenantWithIDDoesNotExist";
    ValidationError[ValidationError["CanNotRemoveTransientUserInstance"] = 78] = "CanNotRemoveTransientUserInstance";
    ValidationError[ValidationError["RoleWithIDDoesNotExist"] = 79] = "RoleWithIDDoesNotExist";
    ValidationError[ValidationError["OnlyCreationOfAdminAndResellerAndClientRolesIsSupported"] = 80] = "OnlyCreationOfAdminAndResellerAndClientRolesIsSupported";
    ValidationError[ValidationError["CanNotCreateRoleOutsideOfContextOfTenant"] = 81] = "CanNotCreateRoleOutsideOfContextOfTenant";
    ValidationError[ValidationError["CanNotUpdateRoleOutsideOfContextOfTenant"] = 82] = "CanNotUpdateRoleOutsideOfContextOfTenant";
    ValidationError[ValidationError["ClientUserNotAllowedToChangeRoleDefinedOnLevelsAbove"] = 83] = "ClientUserNotAllowedToChangeRoleDefinedOnLevelsAbove";
    ValidationError[ValidationError["CannotDeleteRoleWithActiveUsersAssigned"] = 84] = "CannotDeleteRoleWithActiveUsersAssigned";
    ValidationError[ValidationError["CannotChangeTenantOfRoleWithActiveUsersAssigned"] = 85] = "CannotChangeTenantOfRoleWithActiveUsersAssigned";
    ValidationError[ValidationError["CannotHaveRolesWithSameNameForSameTenant"] = 86] = "CannotHaveRolesWithSameNameForSameTenant";
    ValidationError[ValidationError["NoBundleDefinition"] = 87] = "NoBundleDefinition";
    ValidationError[ValidationError["AssetDefinitionNotValidInBundle"] = 88] = "AssetDefinitionNotValidInBundle";
    ValidationError[ValidationError["AssetNotInRma"] = 89] = "AssetNotInRma";
    ValidationError[ValidationError["CanNotLocateAssetForBundle"] = 90] = "CanNotLocateAssetForBundle";
    ValidationError[ValidationError["NoAvailableAssetWithOptionalSerialNumber"] = 91] = "NoAvailableAssetWithOptionalSerialNumber";
    ValidationError[ValidationError["InvalidRmaState"] = 92] = "InvalidRmaState";
    ValidationError[ValidationError["InvalidAssetForTheExchange"] = 93] = "InvalidAssetForTheExchange";
    ValidationError[ValidationError["LanguageCodeDoesNotExists"] = 94] = "LanguageCodeDoesNotExists";
    ValidationError[ValidationError["IncorrectSerialNumber"] = 95] = "IncorrectSerialNumber";
    ValidationError[ValidationError["NoAvailableExchangePool"] = 96] = "NoAvailableExchangePool";
    ValidationError[ValidationError["AssetNotInExchangePool"] = 97] = "AssetNotInExchangePool";
    ValidationError[ValidationError["AssetNotActive"] = 98] = "AssetNotActive";
    ValidationError[ValidationError["NoRepairCenter"] = 99] = "NoRepairCenter";
    ValidationError[ValidationError["NoServiceCenter"] = 100] = "NoServiceCenter";
    ValidationError[ValidationError["AssetNotReadyForRepair"] = 101] = "AssetNotReadyForRepair";
    ValidationError[ValidationError["AssetNotReadyForPostRepair"] = 102] = "AssetNotReadyForPostRepair";
    ValidationError[ValidationError["ExistingRmaIsForAnotherAsset"] = 103] = "ExistingRmaIsForAnotherAsset";
    ValidationError[ValidationError["ExistingRmaAlreadyHasAReclamation"] = 104] = "ExistingRmaAlreadyHasAReclamation";
    ValidationError[ValidationError["CanNotUpdateBundleForAssetInRma"] = 105] = "CanNotUpdateBundleForAssetInRma";
    ValidationError[ValidationError["UserNameNotProvided"] = 106] = "UserNameNotProvided";
    ValidationError[ValidationError["UserNameExists"] = 107] = "UserNameExists";
    ValidationError[ValidationError["UserWithIdNotFound"] = 108] = "UserWithIdNotFound";
    ValidationError[ValidationError["RoleMustHaveAtLeastOnePermission"] = 109] = "RoleMustHaveAtLeastOnePermission";
    ValidationError[ValidationError["AccountIsBlocked"] = 110] = "AccountIsBlocked";
    ValidationError[ValidationError["CategoryNotSpecified"] = 111] = "CategoryNotSpecified";
    ValidationError[ValidationError["CodeNotSpecified"] = 112] = "CodeNotSpecified";
    ValidationError[ValidationError["UserMustBeAssignedToAtLeastOneLocation"] = 113] = "UserMustBeAssignedToAtLeastOneLocation";
    ValidationError[ValidationError["EmailExists"] = 114] = "EmailExists";
    ValidationError[ValidationError["EmailNotValid"] = 115] = "EmailNotValid";
    ValidationError[ValidationError["SelectedLocationsAreNotAllowedForThisUserOnlyLocationsOfTheCurrentTenantAreAllowed"] = 116] = "SelectedLocationsAreNotAllowedForThisUserOnlyLocationsOfTheCurrentTenantAreAllowed";
    ValidationError[ValidationError["SelectedServiceProviderNotAllowed"] = 117] = "SelectedServiceProviderNotAllowed";
    ValidationError[ValidationError["UserCanOnlyBeAssignedMultipleLocationsBelowTheClientLevel"] = 118] = "UserCanOnlyBeAssignedMultipleLocationsBelowTheClientLevel";
    ValidationError[ValidationError["OnlyLocationsOfTheSameClientAreAllowed"] = 119] = "OnlyLocationsOfTheSameClientAreAllowed";
    ValidationError[ValidationError["CanNotAssignRoleHimself"] = 120] = "CanNotAssignRoleHimself";
    ValidationError[ValidationError["UsersAreNotWorkingInSameCompany"] = 121] = "UsersAreNotWorkingInSameCompany";
    ValidationError[ValidationError["UserWithEmailDoesNotExist"] = 122] = "UserWithEmailDoesNotExist";
    ValidationError[ValidationError["TextKeyExistsForTenant"] = 123] = "TextKeyExistsForTenant";
    ValidationError[ValidationError["TextKeyForTranslationNotFound"] = 124] = "TextKeyForTranslationNotFound";
    ValidationError[ValidationError["TenantIsNull"] = 125] = "TenantIsNull";
    ValidationError[ValidationError["UserAuthenticationStatus_AccountBlockedExceededAttempts"] = 126] = "UserAuthenticationStatus_AccountBlockedExceededAttempts";
    ValidationError[ValidationError["UserAuthenticationStatus_AccountIsBlocked"] = 127] = "UserAuthenticationStatus_AccountIsBlocked";
    ValidationError[ValidationError["UserAuthenticationStatus_InvalidCredentials"] = 128] = "UserAuthenticationStatus_InvalidCredentials";
    ValidationError[ValidationError["UserAuthenticationStatus_RequirePasswordChange"] = 129] = "UserAuthenticationStatus_RequirePasswordChange";
    ValidationError[ValidationError["PasswordsDoNotMatch"] = 130] = "PasswordsDoNotMatch";
    ValidationError[ValidationError["CommonError"] = 131] = "CommonError";
    ValidationError[ValidationError["TenantWithIDDoesNotExists"] = 132] = "TenantWithIDDoesNotExists";
    ValidationError[ValidationError["TenantHasChildren"] = 133] = "TenantHasChildren";
    ValidationError[ValidationError["TenantHasAssignedUsers"] = 134] = "TenantHasAssignedUsers";
    ValidationError[ValidationError["TenantHasAssignedRoles"] = 135] = "TenantHasAssignedRoles";
    ValidationError[ValidationError["TenantHasAssignedExchangePools"] = 136] = "TenantHasAssignedExchangePools";
    ValidationError[ValidationError["TenantHasAssignedServiceProviders"] = 137] = "TenantHasAssignedServiceProviders";
    ValidationError[ValidationError["ValueOutOfRange"] = 138] = "ValueOutOfRange";
    ValidationError[ValidationError["ValueDoesNotExists"] = 139] = "ValueDoesNotExists";
    ValidationError[ValidationError["TenantAssetDefinitionWithIdNotFound"] = 140] = "TenantAssetDefinitionWithIdNotFound";
    ValidationError[ValidationError["AssetWithSerialNumberAlreadyExistsInDatabase"] = 141] = "AssetWithSerialNumberAlreadyExistsInDatabase";
    ValidationError[ValidationError["InvalidRoleForLocation"] = 142] = "InvalidRoleForLocation";
    ValidationError[ValidationError["UserDeletionNotAllowed"] = 143] = "UserDeletionNotAllowed";
    ValidationError[ValidationError["IncompleteData"] = 144] = "IncompleteData";
    ValidationError[ValidationError["EntityUsed"] = 145] = "EntityUsed";
    ValidationError[ValidationError["UserAlreadyAssignedToLocation"] = 146] = "UserAlreadyAssignedToLocation";
    ValidationError[ValidationError["DuplicateLocationAndEmailInUserImport"] = 147] = "DuplicateLocationAndEmailInUserImport";
    ValidationError[ValidationError["DuplicateEmailInUserImport"] = 148] = "DuplicateEmailInUserImport";
    ValidationError[ValidationError["NotAuthorized"] = 149] = "NotAuthorized";
    ValidationError[ValidationError["LocationAlreadyExistsForTenant"] = 150] = "LocationAlreadyExistsForTenant";
    ValidationError[ValidationError["ParentLocationDoesNotExistsAsLocation"] = 151] = "ParentLocationDoesNotExistsAsLocation";
    ValidationError[ValidationError["MultipleParentLocationsForLocation"] = 152] = "MultipleParentLocationsForLocation";
    ValidationError[ValidationError["CountryDoesNotExists"] = 153] = "CountryDoesNotExists";
    ValidationError[ValidationError["AssetIsNotAPartOfBundle"] = 154] = "AssetIsNotAPartOfBundle";
    ValidationError[ValidationError["OperationNotEnabled"] = 155] = "OperationNotEnabled";
    ValidationError[ValidationError["ImportPreviewExpired"] = 156] = "ImportPreviewExpired";
    ValidationError[ValidationError["BundleDefinitionInUse"] = 157] = "BundleDefinitionInUse";
    ValidationError[ValidationError["DuplicateModelInBundleDefinition"] = 158] = "DuplicateModelInBundleDefinition";
    ValidationError[ValidationError["SameBundleDefinitionAlreadyExists"] = 159] = "SameBundleDefinitionAlreadyExists";
    ValidationError[ValidationError["SameBundleDefinitionSubsetAlreadyExists"] = 160] = "SameBundleDefinitionSubsetAlreadyExists";
    ValidationError[ValidationError["DuplicatedLocation"] = 161] = "DuplicatedLocation";
    ValidationError[ValidationError["ServiceContractWithIdDoesNotExists"] = 162] = "ServiceContractWithIdDoesNotExists";
    ValidationError[ValidationError["ServiceContractAlreadyExists"] = 163] = "ServiceContractAlreadyExists";
    ValidationError[ValidationError["ServiceContractRepairTimeInvalid"] = 164] = "ServiceContractRepairTimeInvalid";
    ValidationError[ValidationError["ExchangeAssetBlockedForAnotherRma"] = 165] = "ExchangeAssetBlockedForAnotherRma";
    ValidationError[ValidationError["WrongDatabaseVersion"] = 166] = "WrongDatabaseVersion";
    ValidationError[ValidationError["InvalidSoftwareVersion"] = 167] = "InvalidSoftwareVersion";
    ValidationError[ValidationError["ModelTypeNotListed"] = 168] = "ModelTypeNotListed";
    ValidationError[ValidationError["ErrorWhileInsertingMessageToCloudQueue"] = 169] = "ErrorWhileInsertingMessageToCloudQueue";
    ValidationError[ValidationError["CouldNotParseModel"] = 170] = "CouldNotParseModel";
    ValidationError[ValidationError["MultiplePossibleLocations"] = 171] = "MultiplePossibleLocations";
    ValidationError[ValidationError["LocationDoesNotExist"] = 172] = "LocationDoesNotExist";
    ValidationError[ValidationError["LocationNotAChild"] = 173] = "LocationNotAChild";
    ValidationError[ValidationError["ErrorWhileInitializingCloudQueue"] = 174] = "ErrorWhileInitializingCloudQueue";
    ValidationError[ValidationError["AssetDefinitionDoesNotBelongToTenant"] = 175] = "AssetDefinitionDoesNotBelongToTenant";
    ValidationError[ValidationError["DuplicateAssetDefinition"] = 176] = "DuplicateAssetDefinition";
    ValidationError[ValidationError["DuplicateDeactivatedAssetDefinition"] = 177] = "DuplicateDeactivatedAssetDefinition";
    ValidationError[ValidationError["AssetTenantInactive"] = 178] = "AssetTenantInactive";
    ValidationError[ValidationError["DuplicateAssetType"] = 179] = "DuplicateAssetType";
    ValidationError[ValidationError["DuplicateDeactivatedAssetType"] = 180] = "DuplicateDeactivatedAssetType";
    ValidationError[ValidationError["ManufacturerWithSameNameAlreadyExists"] = 181] = "ManufacturerWithSameNameAlreadyExists";
    ValidationError[ValidationError["ServiceProviderWithSameNameAlreadyExists"] = 182] = "ServiceProviderWithSameNameAlreadyExists";
    ValidationError[ValidationError["CannotMoveTenantOfThisType"] = 183] = "CannotMoveTenantOfThisType";
    ValidationError[ValidationError["NewParentIsCurrentChild"] = 184] = "NewParentIsCurrentChild";
    ValidationError[ValidationError["AssetWithSerialNumberAlreadyExistsInDocument"] = 185] = "AssetWithSerialNumberAlreadyExistsInDocument";
    ValidationError[ValidationError["AssigningToLocationAndServiceProviderNotSupported"] = 186] = "AssigningToLocationAndServiceProviderNotSupported";
    ValidationError[ValidationError["AssetStatusCodeDoesNotExists"] = 187] = "AssetStatusCodeDoesNotExists";
    ValidationError[ValidationError["SelectedCustomerIsNotAvailable"] = 188] = "SelectedCustomerIsNotAvailable";
    ValidationError[ValidationError["ServiceContractNumberMissing"] = 189] = "ServiceContractNumberMissing";
    ValidationError[ValidationError["ServiceContractAlreadyAssignedToSerialNumber"] = 190] = "ServiceContractAlreadyAssignedToSerialNumber";
    ValidationError[ValidationError["ServiceContractHasInvalidDuration"] = 191] = "ServiceContractHasInvalidDuration";
    ValidationError[ValidationError["ServiceContractAlreadyExistsInDocument"] = 192] = "ServiceContractAlreadyExistsInDocument";
    ValidationError[ValidationError["BatteryBatchSerialNumberDuplicate"] = 193] = "BatteryBatchSerialNumberDuplicate";
    ValidationError[ValidationError["BatteryBatchSerialNumberMissing"] = 194] = "BatteryBatchSerialNumberMissing";
    ValidationError[ValidationError["InvalidLocationForExchangePool"] = 195] = "InvalidLocationForExchangePool";
    ValidationError[ValidationError["ServiceCenterAssignementAlreadyExists"] = 196] = "ServiceCenterAssignementAlreadyExists";
    ValidationError[ValidationError["RepairCenterAssignementAlreadyExists"] = 197] = "RepairCenterAssignementAlreadyExists";
    ValidationError[ValidationError["CannotChangeLostAsset"] = 198] = "CannotChangeLostAsset";
    ValidationError[ValidationError["SelfCheckDefinitionWithIdDoesNotExist"] = 199] = "SelfCheckDefinitionWithIdDoesNotExist";
    ValidationError[ValidationError["ImportJobWithIdDoesNotExist"] = 200] = "ImportJobWithIdDoesNotExist";
    ValidationError[ValidationError["InvalidFileContentImportJobWithIdDoesNotExist"] = 201] = "InvalidFileContentImportJobWithIdDoesNotExist";
    ValidationError[ValidationError["StartImportJobFailed"] = 202] = "StartImportJobFailed";
    ValidationError[ValidationError["CancelImportJobFailed"] = 203] = "CancelImportJobFailed";
    ValidationError[ValidationError["RollInTaskValidationError"] = 204] = "RollInTaskValidationError";
    ValidationError[ValidationError["RollInTaskAssetValidationError"] = 205] = "RollInTaskAssetValidationError";
    ValidationError[ValidationError["RollInMultipleLocationsForClient"] = 206] = "RollInMultipleLocationsForClient";
    ValidationError[ValidationError["CannotMoveDeviceFromRollInLocation"] = 207] = "CannotMoveDeviceFromRollInLocation";
    ValidationError[ValidationError["CannotMoveDeviceToRollInLocation"] = 208] = "CannotMoveDeviceToRollInLocation";
    ValidationError[ValidationError["RollInMultipleActiveTasksForAsset"] = 209] = "RollInMultipleActiveTasksForAsset";
    ValidationError[ValidationError["RmaGenerateNotAllowedForAssetInActiveRollIn"] = 210] = "RmaGenerateNotAllowedForAssetInActiveRollIn";
    ValidationError[ValidationError["CannotMoveDeviceInludedInActiveRollIn"] = 211] = "CannotMoveDeviceInludedInActiveRollIn";
    ValidationError[ValidationError["NoRollInLocationDefined"] = 212] = "NoRollInLocationDefined";
    ValidationError[ValidationError["CannotChangeRollInAsset"] = 213] = "CannotChangeRollInAsset";
    ValidationError[ValidationError["RollInWithIDNotFound"] = 214] = "RollInWithIDNotFound";
    ValidationError[ValidationError["CannotCloseRollInTask"] = 215] = "CannotCloseRollInTask";
    ValidationError[ValidationError["CannotAssignTrackingNumberToRollInTask"] = 216] = "CannotAssignTrackingNumberToRollInTask";
    ValidationError[ValidationError["TrackingNumberNotProvided"] = 217] = "TrackingNumberNotProvided";
    ValidationError[ValidationError["TrackingNumberNotAcceptable"] = 218] = "TrackingNumberNotAcceptable";
    ValidationError[ValidationError["CannotReceiveRollInAssetAlreadyReceived"] = 219] = "CannotReceiveRollInAssetAlreadyReceived";
    ValidationError[ValidationError["CannotReceiveRollInAssetAlreadyNotReceived"] = 220] = "CannotReceiveRollInAssetAlreadyNotReceived";
    ValidationError[ValidationError["CannotReceiveAssetWithoutRollIn"] = 221] = "CannotReceiveAssetWithoutRollIn";
    ValidationError[ValidationError["CannotMoveDeviceToGroupLocation"] = 222] = "CannotMoveDeviceToGroupLocation";
    ValidationError[ValidationError["CannotGenerateRmaForDeviceOnGroupLocation"] = 223] = "CannotGenerateRmaForDeviceOnGroupLocation";
    ValidationError[ValidationError["CannotChangeStatusForAssetOnGroupLocation"] = 224] = "CannotChangeStatusForAssetOnGroupLocation";
    ValidationError[ValidationError["CannotCreateAssetOnGroupLocation"] = 225] = "CannotCreateAssetOnGroupLocation";
    ValidationError[ValidationError["UserRequestParametersMissing"] = 226] = "UserRequestParametersMissing";
    ValidationError[ValidationError["UserDoesNotExist"] = 227] = "UserDoesNotExist";
    ValidationError[ValidationError["AssetNotFound"] = 228] = "AssetNotFound";
    ValidationError[ValidationError["CannotMoveDeviceToExchangePool"] = 229] = "CannotMoveDeviceToExchangePool";
    ValidationError[ValidationError["CannotMoveDeviceFromExchangePool"] = 230] = "CannotMoveDeviceFromExchangePool";
    ValidationError[ValidationError["CannotCreateAssetOnExchangePool"] = 231] = "CannotCreateAssetOnExchangePool";
    ValidationError[ValidationError["CannotDeleteAssetDefinitionWithTenantAssetDefinitionAssigned"] = 232] = "CannotDeleteAssetDefinitionWithTenantAssetDefinitionAssigned";
    ValidationError[ValidationError["CannotDeleteAssetDefinitionWithAssetAssigned"] = 233] = "CannotDeleteAssetDefinitionWithAssetAssigned";
    ValidationError[ValidationError["AssetTypeNotFound"] = 234] = "AssetTypeNotFound";
    ValidationError[ValidationError["CannotDeleteAssetTypeWithActiveAssetDefinition"] = 235] = "CannotDeleteAssetTypeWithActiveAssetDefinition";
    ValidationError[ValidationError["CannotDeleteManufacturerWithActiveServiceContract"] = 236] = "CannotDeleteManufacturerWithActiveServiceContract";
    ValidationError[ValidationError["CannotDeleteManufacturerUsedInAssetDefinition"] = 237] = "CannotDeleteManufacturerUsedInAssetDefinition";
    ValidationError[ValidationError["CannotDeleteAssetStatusCodeGroupWithActiveStatusCodes"] = 238] = "CannotDeleteAssetStatusCodeGroupWithActiveStatusCodes";
    ValidationError[ValidationError["CustomerModelWithActiveBundlingCannotHaveAlternativeExchangeModelsDefined"] = 239] = "CustomerModelWithActiveBundlingCannotHaveAlternativeExchangeModelsDefined";
    ValidationError[ValidationError["CustomerModelWithAlternativeExchangeModelsCannotHaveActiveBundlingDefined"] = 240] = "CustomerModelWithAlternativeExchangeModelsCannotHaveActiveBundlingDefined";
    ValidationError[ValidationError["InvalidSerialNumberForIntactAsset"] = 241] = "InvalidSerialNumberForIntactAsset";
    ValidationError[ValidationError["StringTooLong"] = 242] = "StringTooLong";
    ValidationError[ValidationError["OnsiteRepairNotPossible"] = 243] = "OnsiteRepairNotPossible";
    ValidationError[ValidationError["AtLeastOneServiceCodeMustBeSelected"] = 244] = "AtLeastOneServiceCodeMustBeSelected";
    ValidationError[ValidationError["AssetStatusCodeGroupNameAlreadyExists"] = 245] = "AssetStatusCodeGroupNameAlreadyExists";
    ValidationError[ValidationError["AssetStatusCodeGroupMissing"] = 246] = "AssetStatusCodeGroupMissing";
    ValidationError[ValidationError["MultipleAssetsFound"] = 247] = "MultipleAssetsFound";
    ValidationError[ValidationError["RepairLimitTooLarge"] = 248] = "RepairLimitTooLarge";
    ValidationError[ValidationError["NoMoreRepairsAvailable"] = 249] = "NoMoreRepairsAvailable";
    ValidationError[ValidationError["BadRmaEventId"] = 250] = "BadRmaEventId";
    ValidationError[ValidationError["LayoutNotFound"] = 251] = "LayoutNotFound";
    ValidationError[ValidationError["LayoutChangeForbiddenForDefaultTenant"] = 252] = "LayoutChangeForbiddenForDefaultTenant";
})(ValidationError || (ValidationError = {}));
var ReleaseNotes = /** @class */ (function () {
    function ReleaseNotes(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReleaseNotes.prototype.init = function (data) {
        if (data) {
            if (data["releaseNote"] && data["releaseNote"].constructor === Array) {
                this.releaseNote = [];
                for (var _i = 0, _a = data["releaseNote"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.releaseNote.push(ReleaseNote.fromJS(item));
                }
            }
        }
    };
    ReleaseNotes.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReleaseNotes();
        result.init(data);
        return result;
    };
    ReleaseNotes.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.releaseNote && this.releaseNote.constructor === Array) {
            data["releaseNote"] = [];
            for (var _i = 0, _a = this.releaseNote; _i < _a.length; _i++) {
                var item = _a[_i];
                data["releaseNote"].push(item.toJSON());
            }
        }
        return data;
    };
    return ReleaseNotes;
}());
export { ReleaseNotes };
var ReleaseNote = /** @class */ (function () {
    function ReleaseNote(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReleaseNote.prototype.init = function (data) {
        if (data) {
            this.version = data["version"] !== undefined ? data["version"] : null;
            if (data["releaseNoteCategories"] && data["releaseNoteCategories"].constructor === Array) {
                this.releaseNoteCategories = [];
                for (var _i = 0, _a = data["releaseNoteCategories"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.releaseNoteCategories.push(ReleaseNoteCategories.fromJS(item));
                }
            }
        }
    };
    ReleaseNote.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReleaseNote();
        result.init(data);
        return result;
    };
    ReleaseNote.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version !== undefined ? this.version : null;
        if (this.releaseNoteCategories && this.releaseNoteCategories.constructor === Array) {
            data["releaseNoteCategories"] = [];
            for (var _i = 0, _a = this.releaseNoteCategories; _i < _a.length; _i++) {
                var item = _a[_i];
                data["releaseNoteCategories"].push(item.toJSON());
            }
        }
        return data;
    };
    return ReleaseNote;
}());
export { ReleaseNote };
var ReleaseNoteCategories = /** @class */ (function () {
    function ReleaseNoteCategories(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReleaseNoteCategories.prototype.init = function (data) {
        if (data) {
            if (data["name"] && data["name"].constructor === Array) {
                this.name = [];
                for (var _i = 0, _a = data["name"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.name.push(ReleaseNoteTranslation.fromJS(item));
                }
            }
            if (data["releaseNoteDetails"] && data["releaseNoteDetails"].constructor === Array) {
                this.releaseNoteDetails = [];
                for (var _b = 0, _c = data["releaseNoteDetails"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.releaseNoteDetails.push(ReleaseNoteDetails.fromJS(item));
                }
            }
        }
    };
    ReleaseNoteCategories.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReleaseNoteCategories();
        result.init(data);
        return result;
    };
    ReleaseNoteCategories.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.name && this.name.constructor === Array) {
            data["name"] = [];
            for (var _i = 0, _a = this.name; _i < _a.length; _i++) {
                var item = _a[_i];
                data["name"].push(item.toJSON());
            }
        }
        if (this.releaseNoteDetails && this.releaseNoteDetails.constructor === Array) {
            data["releaseNoteDetails"] = [];
            for (var _b = 0, _c = this.releaseNoteDetails; _b < _c.length; _b++) {
                var item = _c[_b];
                data["releaseNoteDetails"].push(item.toJSON());
            }
        }
        return data;
    };
    return ReleaseNoteCategories;
}());
export { ReleaseNoteCategories };
var ReleaseNoteTranslation = /** @class */ (function () {
    function ReleaseNoteTranslation(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReleaseNoteTranslation.prototype.init = function (data) {
        if (data) {
            this.languageCode = data["languageCode"] !== undefined ? data["languageCode"] : null;
            this.text = data["text"] !== undefined ? data["text"] : null;
        }
    };
    ReleaseNoteTranslation.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReleaseNoteTranslation();
        result.init(data);
        return result;
    };
    ReleaseNoteTranslation.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode !== undefined ? this.languageCode : null;
        data["text"] = this.text !== undefined ? this.text : null;
        return data;
    };
    return ReleaseNoteTranslation;
}());
export { ReleaseNoteTranslation };
var ReleaseNoteDetails = /** @class */ (function () {
    function ReleaseNoteDetails(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReleaseNoteDetails.prototype.init = function (data) {
        if (data) {
            if (data["note"] && data["note"].constructor === Array) {
                this.note = [];
                for (var _i = 0, _a = data["note"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.note.push(ReleaseNoteTranslation.fromJS(item));
                }
            }
        }
    };
    ReleaseNoteDetails.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReleaseNoteDetails();
        result.init(data);
        return result;
    };
    ReleaseNoteDetails.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.note && this.note.constructor === Array) {
            data["note"] = [];
            for (var _i = 0, _a = this.note; _i < _a.length; _i++) {
                var item = _a[_i];
                data["note"].push(item.toJSON());
            }
        }
        return data;
    };
    return ReleaseNoteDetails;
}());
export { ReleaseNoteDetails };
var OperateBIReportInfo = /** @class */ (function () {
    function OperateBIReportInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OperateBIReportInfo.prototype.init = function (data) {
        if (data) {
            this.reportId = data["reportId"] !== undefined ? data["reportId"] : null;
            this.operateBIReportRoleFilterRequired = data["operateBIReportRoleFilterRequired"] !== undefined ? data["operateBIReportRoleFilterRequired"] : null;
        }
    };
    OperateBIReportInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OperateBIReportInfo();
        result.init(data);
        return result;
    };
    OperateBIReportInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId !== undefined ? this.reportId : null;
        data["operateBIReportRoleFilterRequired"] = this.operateBIReportRoleFilterRequired !== undefined ? this.operateBIReportRoleFilterRequired : null;
        return data;
    };
    return OperateBIReportInfo;
}());
export { OperateBIReportInfo };
var ReportRequestModel = /** @class */ (function () {
    function ReportRequestModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReportRequestModel.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            if (data["reports"] && data["reports"].constructor === Array) {
                this.reports = [];
                for (var _i = 0, _a = data["reports"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.reports.push(OperateBIReportInfo.fromJS(item));
                }
            }
        }
    };
    ReportRequestModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReportRequestModel();
        result.init(data);
        return result;
    };
    ReportRequestModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        if (this.reports && this.reports.constructor === Array) {
            data["reports"] = [];
            for (var _i = 0, _a = this.reports; _i < _a.length; _i++) {
                var item = _a[_i];
                data["reports"].push(item.toJSON());
            }
        }
        return data;
    };
    return ReportRequestModel;
}());
export { ReportRequestModel };
var EmbedContent = /** @class */ (function () {
    function EmbedContent(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EmbedContent.prototype.init = function (data) {
        if (data) {
            this.embedToken = data["embedToken"] !== undefined ? data["embedToken"] : null;
            this.embedUrl = data["embedUrl"] !== undefined ? data["embedUrl"] : null;
            this.reportId = data["reportId"] !== undefined ? data["reportId"] : null;
            this.reportName = data["reportName"] !== undefined ? data["reportName"] : null;
            this.reportOrder = data["reportOrder"] !== undefined ? data["reportOrder"] : null;
            this.reportIcon = data["reportIcon"] !== undefined ? data["reportIcon"] : null;
        }
    };
    EmbedContent.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EmbedContent();
        result.init(data);
        return result;
    };
    EmbedContent.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["embedToken"] = this.embedToken !== undefined ? this.embedToken : null;
        data["embedUrl"] = this.embedUrl !== undefined ? this.embedUrl : null;
        data["reportId"] = this.reportId !== undefined ? this.reportId : null;
        data["reportName"] = this.reportName !== undefined ? this.reportName : null;
        data["reportOrder"] = this.reportOrder !== undefined ? this.reportOrder : null;
        data["reportIcon"] = this.reportIcon !== undefined ? this.reportIcon : null;
        return data;
    };
    return EmbedContent;
}());
export { EmbedContent };
